import { render, staticRenderFns } from "./PrintTemplateEditor.vue?vue&type=template&id=1ff34924&scoped=true"
import script from "./PrintTemplateEditor.vue?vue&type=script&lang=js"
export * from "./PrintTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./PrintTemplateEditor.vue?vue&type=style&index=0&id=1ff34924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff34924",
  null
  
)

export default component.exports